import { SidebarMenu } from "../../../ducks/app";
import { SidebarMenuItem } from "../../atoms/SidebarMenuItem";

type Props = {
  sidebarMenusToShow: SidebarMenu[];
  selectedMenuPath: string;
  onSidebarMenuClick: (path: string) => void;
};

export const SidebarMenus: React.FC<Props> = ({
  sidebarMenusToShow,
  selectedMenuPath,
  onSidebarMenuClick,
}) => {
  return (
    <>
      {sidebarMenusToShow.map((menu, index) => (
        <SidebarMenuItem
          key={index}
          menu={menu}
          selectedMenuPath={selectedMenuPath}
          onClick={onSidebarMenuClick}
        />
      ))}
    </>
  );
};
